import { render, staticRenderFns } from "./RightToWork.vue?vue&type=template&id=5938d129&scoped=true"
import script from "./RightToWork.vue?vue&type=script&lang=js"
export * from "./RightToWork.vue?vue&type=script&lang=js"
import style0 from "./RightToWork.vue?vue&type=style&index=0&id=5938d129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938d129",
  null
  
)

export default component.exports